// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"46791b1b","404":"10c1abaf","470":"58cf9d6c","496":"1fc56cb0","498":"1eb30e54","787":"e3bf7aa3","968":"383ae830"}[chunkId] + ".chunk.js";
};